import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sc_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 2600);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-6 z-[90] max-w-sm border border-black/10 bg-white p-6 shadow-xl shadow-black/10"
        >
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 place-items-center border border-bronze/40">
              <Cookie className="h-4 w-4 text-bronze" strokeWidth={1.8} />
            </span>
            <h3 className="font-display text-lg font-bold uppercase tracking-wide text-ink">
              Cookies
            </h3>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-fog">
            We use essential cookies to run this site and optional analytics to
            improve it. Read our{" "}
            <Link
              data-testid="cookie-policy-link"
              to="/cookies"
              className="font-medium text-bronze underline underline-offset-2 hover:text-ink"
            >
              Cookies Policy
            </Link>
            .
          </p>
          <div className="mt-5 flex gap-3">
            <button
              data-testid="cookie-accept-btn"
              onClick={() => choose("accepted")}
              className="flex-1 bg-bronze px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-ink hover:text-bronze"
            >
              Accept
            </button>
            <button
              data-testid="cookie-decline-btn"
              onClick={() => choose("declined")}
              className="flex-1 border border-black/20 px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:border-bronze hover:text-bronze"
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
